import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export default async function PostBank(salesOrg: string, data: any) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      bank: data
    },
    url: `${BASE_URL}/api/bank/save`,
  };

  return await AXIOS_INSTANCE(config).then((v) => v.data);
}
